import {PRODUCT_NO_IMG} from "../constants";
import Swiper, {Autoplay, EffectFade, FreeMode, Navigation, Pagination, Thumbs} from "swiper";

export function productImg(product) {
    if (product?.preview_image?.original_url) return product.preview_image.original_url
    else if (Array.isArray(product?.images) && !!product.images.length) return product.images[0].original_url
    return PRODUCT_NO_IMG
}

export function addLoadListenerToLazyLoadObjects() {
    const lazyImages = document.querySelectorAll('.lazy');
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                if (img.dataset.src !== undefined)
                    img.src = img.dataset.src; // подставляем настоящий src
                if (img.dataset.srcset !== undefined)
                    img.srcset = img.dataset.srcset;
                img.classList.remove("lazy");
                observer.unobserve(img); // больше не наблюдаем за этим изображением
            }
        });
    }, {
        rootMargin: '50px' // начинает загрузку за 50px до появления
    });

    lazyImages.forEach(img => observer.observe(img));
}

function loadImageInSlide(slideEl) {
    const lazyImages = slideEl.querySelectorAll('.lazy-slider');
    lazyImages.forEach((img) => {
        if (img.dataset.src !== undefined) {
            img.src = img.dataset.src;
        }
        if (img.dataset.srcset !== undefined) {
            img.srcset = img.dataset.srcset;
        }
        img.classList.remove('lazy-slider');
    });
}

export function initSliders() {
    if (document.querySelector('.cards-main__slider')) {
        let arrsPrev = document.querySelectorAll(".cards-main-button_prev");
        let arrsNext = document.querySelectorAll(".cards-main-button_next");
        let cardMainSlider = document.querySelectorAll(".cards-main__slider");
        for (let index = 0; index < cardMainSlider.length; index++) {
            const slider = cardMainSlider[index];
            new Swiper(slider, {
                modules: [Pagination, Navigation],
                observer: true,
                observeParents: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 800,
                watchOverflow: true,
                effect: "fade",
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                navigation: {
                    prevEl: arrsPrev[index],
                    nextEl: arrsNext[index]
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    }
                }
            });
        }
    }
    if (document.querySelector('.news-block__slider')) {
        new Swiper('.news-block__slider', {
            modules: [Pagination],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            pagination: {
                el: ".news-block__pagination",
                clickable: true
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            }
        });
    }

    if (document.querySelector('.cards-article__slider')) {
        let arrsPrev = document.querySelectorAll(".cards-main-button_prev");
        let arrsNext = document.querySelectorAll(".cards-main-button_next");
        let cardMainSlider = document.querySelectorAll(".cards-article__slider");
        for (let index = 0; index < cardMainSlider.length; index++) {
            const slider = cardMainSlider[index];
            new Swiper(slider, {
                modules: [Pagination, Navigation],
                observer: true,
                observeParents: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 800,
                watchOverflow: true,
                effect: "fade",
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    prevEl: arrsPrev[index],
                    nextEl: arrsNext[index],
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    992: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    1220: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                },
            });
        }
    }

    if (document.querySelector('.card__slider')) {
        let arrsPrev = document.querySelectorAll(".card-button_prev");
        let arrsNext = document.querySelectorAll(".card-button_next");
        let cardSlider = document.querySelectorAll(".card__slider");

        for (let index = 0; index < cardSlider.length; index++) {
            const slider = cardSlider[index];
            new Swiper(slider, {
                modules: [Pagination, EffectFade, Navigation],
                observer: true,
                observeParents: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 800,
                watchOverflow: true,
                effect: "fade",
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    prevEl: arrsPrev[index],
                    nextEl: arrsNext[index]
                },
                on: {
                    slideChange(swiper) {
                        loadImageInSlide(swiper.slides[swiper.activeIndex]);
                    }
                }
            });

            slider.querySelectorAll('.card__slide-hidden').forEach(el => {
                el.classList.remove('card__slide-hidden');
            });
        }
    }

    if (document.querySelector('.cards-swiper')) {
        new Swiper('.cards-swiper ', {
            modules: [Navigation, Pagination, FreeMode],
            observer: true,
            observeParents: true,
            slidesPerView: 4,
            spaceBetween: 8,
            autoHeight: true,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            freeMode: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            breakpoints: {
                320: {
                    slidesPerView: 'auto',
                },
                768: {
                    slidesPerView: 3,
                },
                1170: {
                    slidesPerView: 4,
                },
            },
            on: {}
        });
    }
    if (document.querySelector('.main__slider')) {
        new Swiper('.main__slider ', {
            modules: [Navigation, Pagination, Autoplay],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            loop: true,
            touchRatio: 0,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            on: {}
        });
    }
    if (document.querySelector('.similar__slider')) {
        new Swiper('.similar__slider', {
            modules: [Navigation, Pagination, FreeMode],
            observer: true,
            observeParents: true,
            autoHeight: true,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            freeMode: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            breakpoints: {
                320: {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 4,
                },
                1170: {
                    slidesPerView: 5,
                    spaceBetween: 26,
                },
            },
            on: {}
        });
    }
    if (document.querySelector('.simple-swiper')) {
        const simpleSlider = new Swiper('.simple-swiper', {
            modules: [Navigation, Pagination],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            on: {}
        });

        if (document.querySelector('.popup-advertising__slider')) {
            const popupSlider = new Swiper('.popup-advertising__slider', {
                modules: [Navigation, Pagination],
                observer: true,
                observeParents: true,
                slidesPerView: 1,
                spaceBetween: 0,
                autoHeight: true,
                speed: 800,
                watchOverflow: true,
                simulateTouch: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    prevEl: '.popup-swiper-button-prev',
                    nextEl: '.popup-swiper-button-next',
                },
                on: {}
            });
            simpleSlider.on('click', function () {
                let i = simpleSlider.activeIndex;
                popupSlider.slideTo(i, 0)
            });
        }
    }

    if (document.querySelector('.company__slider')) {
        new Swiper('.company__slider', {
            modules: [Navigation, Pagination, FreeMode],
            observer: true,
            observeParents: true,
            slidesPerView: "auto",
            spaceBetween: 7,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            freeMode: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            breakpoints: {
                320: {
                    centeredSlides: true,
                },
                1171: {
                    centeredSlides: false,
                },
            },
            on: {}
        });
    }

    if (document.querySelector('.main-product__slider') && document.querySelector('.main-product__thumbs-slider')) {
        new Swiper('.main-product__slider', {
            modules: [Navigation, Pagination, FreeMode, Thumbs],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            thumbs: {
                swiper: {
                    el: '.main-product__thumbs-slider',
                    slidesPerView: 5,
                    spaceBetween: 13,
                    touchRatio: 0,
                }
            },
            breakpoints: {
                320: {
                    centeredSlides: true,
                },
                1171: {
                    centeredSlides: false,
                },
            },
            on: {}
        });
    }

    if (document.querySelector(".main-blog-slider__slider")) {
        new Swiper(".main-blog-slider__slider", {
            modules: [Pagination],
            observer: true,
            observeParents: true,
            speed: 800,
            watchOverflow: true,
            freeMode: true,
            pagination: {
                el: ".main-blog-slider__pagination",
                clickable: true
            },
            breakpoints: {
                320: {
                    spaceBetween: 0,
                    slidesPerView: 1
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: "auto"
                }
            },
            on: {}
        });
    }
}
